import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./EditDepartment.css";
import Header from "../../../../../../header/header";
import Navvbar from "../../../../../../header/Navvbar";

const EditDepartment = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    dailyLimit: "",
    customId: "",
  });

  const departmentsOrder = [
    "CROWN AND BRIDGE",
    "ORTHODONTIC",
    "IMPLANTS",
    "All Departments",
  ];

  // Case Settings wali sidebar ke links
  // ⚠️ "to" ko apne project ke asal routes se match kar lein
  const sidebarLinks = [
    { label: "Lab Details", to: "/settings" },
    { label: "Store", to: "#", disabled: true },
    { label: "Users", to: "/users" },
    { label: "Permission Groups", to: "#", disabled: true },
    { label: "Accounts", to: "/accounts" },
    { label: "Finances", to: "/finances" },
    { label: "Case Settings", to: "/case-settings" },
  ];

  useEffect(() => {
    // Yahan API se data laa sakte hain
    if (id) {
      setFormData({
        name: "All Departments",
        dailyLimit: "",
        customId: "",
      });
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    console.log("Saving Data:", formData);
    alert("Department saved successfully!");
    navigate(-1);
  };

  return (
    <div className="ed-layout">
      <div className="ed-header-container">
        <Header />
        <Navvbar />
      </div>

      <div className="ed-main-wrapper">
        <div className="ed-row">
          {/* ===== SIDEBAR (Case Settings jaisi) ===== */}
          <div className="ed-sidebar">
            <h4 className="ed-sidebar-title">Settings</h4>
            <div className="ed-sidebar-links">
              {sidebarLinks.map((item) => (
                <div key={item.label} className="ed-sidebar-link-wrapper">
                  {item.disabled ? (
                    <span className="ed-sidebar-link ed-disabled">
                      {item.label}
                    </span>
                  ) : (
                    <Link to={item.to} className="ed-sidebar-link">
                      {item.label}
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* ===== CONTENT ===== */}
          <div className="ed-content">
            <h2 className="ed-title">Edit Department</h2>

            {/* Section 1: Department Details */}
            <div className="ed-section">
              {/* ✅ Line ab yahan (Department Details ke neeche) */}
              <h5 className="ed-section-title ed-section-title-line">
                Department Details
              </h5>
              <div className="ed-form-box">
                <div className="ed-form-row">
                  <label className="ed-form-label">
                    Name <span className="ed-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="ed-form-input"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="ed-form-row">
                  <label className="ed-form-label">Daily Limit</label>
                  <div className="ed-daily-limit-group">
                    <input
                      type="number"
                      name="dailyLimit"
                      className="ed-form-input ed-limit-input"
                      value={formData.dailyLimit}
                      onChange={handleChange}
                    />
                    <span className="ed-limit-text">Task Blocks</span>
                  </div>
                </div>

                <div className="ed-form-row">
                  <label className="ed-form-label">Custom ID</label>
                  <input
                    type="text"
                    name="customId"
                    className="ed-form-input"
                    placeholder="Custom Identifier"
                    value={formData.customId}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Section 2: Departments Order */}
            <div className="ed-section" style={{ marginTop: "20px" }}>
              <h5 className="ed-section-title">Departments Order</h5>
              <div className="ed-order-list">
                {departmentsOrder.map((dept, index) => (
                  <div key={index} className="ed-order-item">
                    {dept}
                  </div>
                ))}
              </div>
            </div>

            {/* Actions - Only Save Button */}
            <div className="ed-actions">
              <button className="ed-btn" onClick={handleSave}>
                <span className="ed-save-icon">💾</span> Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDepartment;